module.exports = __webpack_public_path__ + "img/knowledge.b0f7791a.svg";